import React from 'react';
import { Box, FormControlLabel, makeStyles } from '@material-ui/core';
import { CheckBox } from '@components/CheckBox/CheckBox';
import { useCommentsContext } from '@components/CaseDetails/CommentsSection/CommentsContext/CommentsContext';
import classNames from 'classnames';

const useStyles = makeStyles(theme => ({
	checkboxWrapper: {
		'padding': theme.spacing(1),
		'&.MuiBox-root': {
			'& .MuiFormControlLabel-root': {
				'& .MuiIconButton-root': {
					visibility: 'visible',
				},
			}
		}
	},
	checkedLabel: {
		color: theme.palette.primary.main,
	}
}));

export const ShowHistoryCheckbox: React.FC = () => {
	const classes = useStyles();
	const { showHistory, setShowHistory } = useCommentsContext();

	return (
		<Box className={classes.checkboxWrapper}>
			<FormControlLabel
				className={classNames({
					[classes.checkedLabel]: showHistory,
				})}
				control={
					<CheckBox
						data-field="showHistoryCheckbox"
						color="primary"
						checked={showHistory}
						onChange={() => setShowHistory(!showHistory)}
					/>
				}
				label="Show History" />
		</Box>
	);
};
